module.exports = __webpack_public_path__ + "img/momo.f5aaeb83.jpg";